import React, { useCallback, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { fetchTemplate } from '@app/src/view/Loading/template/state/template/actions';
import { TemplateShimmer } from '@app/src/view/Loading/template/components/TemplateShimmer';
import { Wrapper, Iframe } from './styled';
import { Error } from '@app/src/view/Loading/template/components/Error';

const SERVER_ERROR = 500;
const NOT_FOUND_ERROR = 404;

interface Props {
  history: any;
}

export const Template: React.FC<Props> = ({ history }) => {

  const isFetching: boolean = useSelector(state => state.template.isFetching);
  const { url } = useSelector(state => state.template.data.template);
  const urlPath: string = history.location.pathname;
  const statusCode: number = useSelector(state => state.template.statusCode);
  const isValidPath: boolean = urlPath.substr(1).includes('.html');

  const dispatch = useDispatch();
  const handleFetchTemplate = useCallback(
    (url) => dispatch(fetchTemplate(url)),
    [dispatch]
  );

  useEffect(() => {
    isValidPath && handleFetchTemplate(urlPath);
  }, []);

  if (isFetching) {
    return <TemplateShimmer />
  }

  if (statusCode === SERVER_ERROR || statusCode === NOT_FOUND_ERROR || !isValidPath) {
    return <Error isValidPath={isValidPath} />
  }

  return(
    <Wrapper>
      <Iframe src={url} />
    </Wrapper>
  );
};
